import { render } from "./HR_Employee_Badge.vue?vue&type=template&id=20913c83&scoped=true"
import script from "./HR_Employee_Badge.vue?vue&type=script&lang=js"
export * from "./HR_Employee_Badge.vue?vue&type=script&lang=js"

import "./HR_Employee_Badge.vue?vue&type=style&index=0&id=20913c83&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20913c83"]])

export default __exports__